<!-- eslint-disable -->
<script setup>
import { useI18n } from 'vue-i18n';
import { useRegisterStore } from '../../stores/register';

const { t } = useI18n();
const registerStore = useRegisterStore();
</script>
<template>
	<div class="register-form-field">
		<label> {{$t('account.login.username')}}</label>
		<input class="form-input" :placeholder="$t('account.login.username')" type="text" @keyup="registerStore.validateUsername" v-model="registerStore.register_input_fields.username" name="full_name" required="required" />
		<div class="register-form-list" v-if="registerStore.register_errors.username.error">
			<div class="password-meter">
				<div class="password-meter-bar">
					<div class="password-meter-bar-inn"></div>
				</div>
			</div>
			<p>
				<img src="@/assets/svgs/cross.svg" alt=""/>
				&nbsp;
				<span v-if="registerStore.register_errors.username.error == 'error_characters_and_numbers'">
					{{ $t('account.register.error_only_characters_and_numbers') }}
				</span>
				<span v-else-if="registerStore.register_errors.username.error == 'username_required'">
					{{ $t('account.register.error_username_required') }}
				</span>
				<span v-else-if="registerStore.register_errors.hasOwnProperty('username')">
					{{ registerStore.register_errors.username.error }}
				</span>
			</p>
		</div>
	</div>
</template>

<style scoped>
.register-form-main .register-outer-form .register-inner-form .password-meter .password-meter-bar {
	background-color:var(--red);
	margin-bottom:5px;
}
.register-form-main .register-form-list {
	margin-top:unset;
	padding-top:5px;
}
html[dir="rtl"] .register-form-main .register-outer-form .register-inner-form .form-input {
	padding: 10px 15px 10px 15px;
}
</style>